import styled from "styled-components";



//*----------------------------------------------------------------
//Elemento que contendra el contenido ajustable de las diferentes secciones que contendra la pagina web
const Contenido = styled.div`
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    background-color: inherit;
`;
export default Contenido;
//*----------------------------------------------------------------